<style lang="stylus">
    .InsertTimeline-mask
        modal-mask()
        .InsertTimeline-modal
            width 610px
            .dialog-slot
                padding: 0
            .dialog-btnbox-normal
                width fit-content
            .InsertTimeline-contentbox
                position relative
                height 400px
                overflow auto
                padding 0 24px
                padding-top: 20px
                .InsertTimeline-type-box
                    .InsertTimeline-type-title
                        font-size 12px
                        margin-bottom: 10px
                        margin-top: -4px
                    .InsertTimeline-item-box
                        display flex
                        justify-content: space-between;
                        flex-wrap wrap
                        .InsertTimeline-item
                            margin-bottom: 24px
                            height 150px
                            width 266px
                            border-radius 6px
                            text-align center
                            display flex
                            align-content center
                            flex-wrap wrap
                            justify-content center
                            background-repeat no-repeat
                            background-size 100% 100%
                            border 1px solid transparent
                            &:hover{
                                border-color var(--themeColor)
                            }
                            img
                                margin-bottom 8px
                                width:100%;
                                height:40%;
                            .InsertTimeline-item-name
                                margin-top 110px
                        .InsertTimeline-item-active
                            border-color var(--themeColor)
            .InsertTimeline-footer
                display flex
                justify-content space-between
                align-items center
                padding 24px
                .ivu-checkbox
                    margin-right 10px
                    &:not(.ivu-checkbox-checked)
                        .ivu-checkbox-inner
                            background-color var(--bg-color-tertiary)
</style>

<template>
    <div class="InsertTimeline-mask">
        <Dialog class="InsertTimeline-modal" :title="$t('title')" :isShow="true" @close="closeModal">
            <div class="InsertTimeline-contentbox">
                <div class="InsertTimeline-type-box" v-for="(data, index) in insertData" :key="index">
                    <div class="InsertTimeline-type-title">{{ $t(data.name) }}</div>
                    <div class="InsertTimeline-item-box">
                        <div
                            class="InsertTimeline-item"
                            :class="{ 'InsertTimeline-item-active': item.id == selectItem.id }"
                            v-for="(item, index) in data.child"
                            :style="{ 'background-Image': `url(${item.url})` }"
                            :key="index"
                            @click="selectItem = item"
                            @dblclick="dblclick(item)"
                        ></div>
                    </div>
                </div>
            </div>
            <div class="InsertTimeline-footer">
                <Checkbox v-model="openLib">{{ $t("openLib") }}</Checkbox>
                <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                    <div @click="closeModal()">{{ $t("cancel") }}</div>
                    <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    import appConfig from "@/public/globalConfig";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class InsertTimeline extends Vue {
        @Inject()
        ["showMessage"];

        libraryWorkerURL: string = appConfig.libraryWorkerURL;
        openLib: boolean = false;
        tipSrc: string = "";
        // lib顺序为[groupID, tableID, index]
        selectItem = {
            id: 0,
            lib: [[92, 279, 0]],
            url: require("@/app/assets/img/timeline/HTimeline_1.png"),
            tip: "",
        };

        insertData: Array<object> = [
            {
                name: "horizontal",
                child: [
                    {
                        id: 0,
                        lib: [[92, 279, 0]],
                        url: require("@/app/assets/img/timeline/HTimeline_1.png"),
                        tip: "",
                    },
                    {
                        id: 1,
                        lib: [[92, 279, 9]],
                        url: require("@/app/assets/img/timeline/HTimeline_2.png"),
                        tip: "",
                    },
                    {
                        id: 2,
                        lib: [[92, 279, 1]],
                        url: require("@/app/assets/img/timeline/HTimeline_3.png"),
                        tip: "",
                    },
                    {
                        id: 3,
                        lib: [[92, 279, 2]],
                        url: require("@/app/assets/img/timeline/HTimeline_4.png"),
                        tip: "",
                    },
                    {
                        id: 4,
                        lib: [[92, 279, 3]],
                        url: require("@/app/assets/img/timeline/HTimeline_5.png"),
                        tip: "",
                    },
                    {
                        id: 5,
                        lib: [[92, 279, 4]],
                        url: require("@/app/assets/img/timeline/HTimeline_6.png"),
                        tip: "",
                    },
                    {
                        id: 6,
                        lib: [
                            [28, 260, 0],
                            [28, 260, 17],
                            [28, 260, 17],
                            [28, 260, 10],
                            [28, 260, 10],
                            [28, 260, 14],
                        ],
                        url: require("@/app/assets/img/timeline/HTimeline_7.png"),
                        tip: "",
                    },
                ],
            },
            {
                name: "vertical",
                child: [
                    {
                        id: 7,
                        lib: [[92, 279, 5]],
                        url: require("@/app/assets/img/timeline/VTimeline_1.png"),
                        tip: "",
                    },
                    {
                        id: 8,
                        lib: [[92, 279, 6]],
                        url: require("@/app/assets/img/timeline/VTimeline_2.png"),
                        tip: "",
                    },
                    {
                        id: 9,
                        lib: [[92, 279, 7]],
                        url: require("@/app/assets/img/timeline/VTimeline_3.png"),
                        tip: "",
                    },
                    {
                        id: 10,
                        lib: [[92, 279, 8]],
                        url: require("@/app/assets/img/timeline/VTimeline_4.png"),
                        tip: "",
                    },
                ],
            },
        ];
        insertTimeline() {
            let view = window["_view"];
            if (!view) return;
            this.sensors.track("newTimeline", {
                Catalogues: "SpecificDiagrams",
                new_timeline_place: "insertButton",
                new_timeline_type: "" + this.selectItem.id,
            });
            console.log(this.selectItem.lib);
            let GROUP_NAME = "Basic Diagrams", // 2021年底改为Smart Shapes
                TABLE_NAME = "Timeline",
                PROGROUP_NAME = "Project Management",
                PROTABLE_NAME = "Project Timeline";

            // 已经历过符号库更改id以及groupname, 此后不能再改id
            for (let i = 0; i < this.menuList.length; i++) {
                let menuItem = this.menuList[i];
                if (menuItem.id == 92 && menuItem.groupName != GROUP_NAME) GROUP_NAME = menuItem.groupName;
                else if (menuItem.id == 28 && menuItem.groupName != PROGROUP_NAME) PROGROUP_NAME = menuItem.groupName;
            }

            let contentList = [],
                nameUList = [],
                localNameList = [],
                libList = [];

            let pList = [];
            let p1 = new Promise((res, rej) => {
                let noShape = true;
                for (let i = 0; i < this.selectItem.lib.length; i++) {
                    if (this.selectItem.lib[i][0] == 92 && this.selectItem.lib[i][1] == 279) {
                        noShape = false;
                        break;
                    }
                }
                if (noShape) {
                    res(true);
                } else {
                    let opendb = window.indexedDB.open(GROUP_NAME);
                    opendb.onsuccess = (e) => {
                        let db = (e.target as IDBOpenDBRequest).result;
                        let transaction = db.transaction(TABLE_NAME);
                        let store = transaction.objectStore(TABLE_NAME);
                        let request = store.openCursor();
                        request.onsuccess = (e) => {
                            let cursor = (e.target as IDBRequest).result;
                            if (cursor) {
                                let cursorkey = cursor.key;
                                for (let i = 0; i < this.selectItem.lib.length; i++) {
                                    if (this.selectItem.lib[i][0] != 92 || this.selectItem.lib[i][1] != 279) continue;
                                    let idx = this.selectItem.lib[i][2];
                                    if (idx == cursorkey) {
                                        let cursordata = cursor.value;
                                        contentList[i] = cursordata.data;
                                        nameUList[i] = cursordata.name;
                                        localNameList[i] = cursordata[this.lang + "_name"];
                                        libList[i] = 279;
                                    }
                                }
                                cursor.continue();
                            } else {
                                res(true);
                            }
                        };
                        request.onerror = (e) => {
                            rej();
                        };
                        db.close();
                    };
                    opendb.onerror = (e) => {
                        rej();
                    };
                }
            });
            let p2 = new Promise((res, rej) => {
                let noShape = true;
                for (let i = 0; i < this.selectItem.lib.length; i++) {
                    if (this.selectItem.lib[i][0] == 28 && this.selectItem.lib[i][1] == 260) {
                        noShape = false;
                        break;
                    }
                }
                if (noShape) {
                    res(true);
                } else {
                    let opendb = window.indexedDB.open(PROGROUP_NAME);
                    opendb.onsuccess = (e) => {
                        let db = (e.target as IDBOpenDBRequest).result;
                        let transaction = db.transaction(PROTABLE_NAME);
                        let store = transaction.objectStore(PROTABLE_NAME);
                        let request = store.openCursor();
                        request.onsuccess = (e) => {
                            let cursor = (e.target as IDBRequest).result;
                            if (cursor) {
                                let cursorkey = cursor.key;
                                for (let i = 0; i < this.selectItem.lib.length; i++) {
                                    if (this.selectItem.lib[i][0] != 28 || this.selectItem.lib[i][1] != 260) continue;
                                    let idx = this.selectItem.lib[i][2];
                                    if (idx == cursorkey) {
                                        let cursordata = cursor.value;
                                        contentList[i] = cursordata.data;
                                        nameUList[i] = cursordata.name;
                                        localNameList[i] = cursordata[this.lang + "_name"];
                                        libList[i] = 260;
                                    }
                                }
                                cursor.continue();
                            } else {
                                res(true);
                            }
                        };
                        request.onerror = (e) => {
                            rej();
                        };
                        db.close();
                    };
                    opendb.onerror = (e) => {
                        rej();
                    };
                }
            });
            pList.push(p1);
            pList.push(p2);
            Promise.all(pList).then((e) => {
                console.log(contentList, nameUList, localNameList, libList, this.selectItem.id);
                if (this.openLib) {
                    this.openLibrary().then((e) => {
                        view.createTimeline(contentList, nameUList, localNameList, libList, this.selectItem.id);
                    });
                } else {
                    view.createTimeline(contentList, nameUList, localNameList, libList, this.selectItem.id);
                }
            });
        }

        openLibrary() {
            let libList = [279, 260, 280, 281, 282, 283, 284, 271];
            let menu = this.$store.state.library.menuList;
            let downloadList = [];
            let libObj = {};
            let checkbox = this.$store.state.library.checkbox;
            let tempCheckbox = JSON.parse(JSON.stringify(checkbox));

            let getInfoByTableID = (id, menu) => {
                let obj = {
                    tableID: id,
                    name: "",
                    version: "",
                    type: "",
                    mcount: 0,
                    group: "",
                };
                let url = "";
                for (let i = 0; i < menu.length; ++i) {
                    if (menu[i].children.length > 0) {
                        let child = menu[i].children;
                        for (let j = 0; j < child.length; ++j) {
                            if (child[j].id == id) {
                                obj.name = child[j].tableName;
                                obj.version = child[j].version;
                                obj.type = child[j].type;
                                obj.mcount = child[j].mcount;
                                obj.group = menu[i].groupName;
                                url = child[j].url;
                                break;
                            }
                        }
                    }
                }
                return { url: url, data: obj };
            };
            let checkLocalStorage = (libObj, downloadList) => {
                for (let i = 0; i < libList.length; i++) {
                    let libID = libList[i];
                    let obj = getInfoByTableID(libID, menu);
                    if (obj.url != "") {
                        downloadList.push(obj);
                        if (libObj[obj["data"]["group"]]) {
                            libObj[obj["data"]["group"]].push(libID);
                        } else {
                            libObj[obj["data"]["group"]] = [libID];
                        }
                    }
                }
            };

            checkLocalStorage(libObj, downloadList);
            return new Promise((rs, rj) => {
                if (downloadList.length != 0) {
                    let worker = new Worker(this.libraryWorkerURL);
                    worker.postMessage({
                        type: "openFile",
                        data: downloadList,
                        lang: appConfig.language,
                        urls: this.urls,
                    });
                    this.toggleLoading(true, "library");
                    let process = 0;
                    worker.onmessage = (e) => {
                        let message = e.data;
                        if (message.type === "loaded") {
                            this.toggleLoading(false);
                            let keyArr = Object.keys(libObj);
                            for (let name of keyArr) {
                                if (Object.keys(tempCheckbox).includes(name)) {
                                    tempCheckbox[name] = libObj[name];
                                } else {
                                }
                            }
                            this.$store.commit("setLibraryState", {
                                type: "checkbox",
                                data: tempCheckbox,
                            });
                            worker.terminate();
                            rs();
                        }
                        if (message.type === "process") {
                            process = Math.max(process, message.process);
                            this.setProcess(process);
                        }
                    };
                } else {
                    rs();
                }
            });
        }
        getSelectType() {
            if (this.selectItem.id >= 7) {
                return "vertical-" + (this.selectItem.id - 7);
            } else {
                return "horizontal" + this.selectItem.id;
            }
        }
        confirm() {
            this.$track("timeline", "clickbutton", `result: yes;openlibrary: ${this.openLib ? "yes" : "no"};type: ${this.getSelectType()}`);
            this.closeModal();
            this.insertTimeline();
        }

        cancel() {
            this.$track("timeline", "clickbutton", `result: no;openlibrary: ${this.openLib ? "yes" : "no"};type: ${this.getSelectType()}`);
            this.closeModal();
        }

        dblclick(item) {
            this.selectItem = item;
            this.confirm();
        }

        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }

        setProcess(num) {
            this.$store.commit("setStatus", {
                type: "LoadingProcess",
                data: num > 1 ? 1 : num < 0 ? 0 : num,
            });
        }

        toggleLoading(type, textStr = "library") {
            if (type) {
                this.setProcess(0);
                this.$store.commit("setStatus", {
                    type: "loadingTextType",
                    data: textStr,
                });
            }
            this.$store.commit("setStatus", {
                type: "Loading",
                data: type,
            });
        }

        mounted() {}

        created() {}

        get menuList() {
            return this.$store.state.library.menuList;
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "插入时间线",
    "horizontal": "水平时间线",
    "vertical": "垂直时间线",
    "openLib": "同时打开时间线相关图库",
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "title": "Insert Timeline",
    "horizontal": "Horizontal Timeline",
    "vertical": "Vertical Timeline",
    "openLib": "Open Timeline-related libraries as well",
    "confirm": "Insert",
    "cancel": "Cancel"
  },
  "fr": {
    "title": "Insérer une chronologie",
    "horizontal": "Chronologie horizontale",
    "vertical": "Chronologie verticale",
    "openLib": "Ouvrir également la galerie liée à la chronologie",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "pt": {
    "title": "Inserir Linha do Tempo",
    "horizontal": "Linha do Tempo Horizontal",
    "vertical": "Linha do Tempo Vertical",
    "openLib": "Abra bibliotecas relacionadas à linha do tempo também",
    "confirm": "Inserir",
    "cancel": "Cancelar"
  },
  "es": {
    "title": "Insertar cronología",
    "horizontal": "Línea de tiempo horizontal",
    "vertical": "Línea de tiempo vertical",
    "openLib": "Bibliotecas abiertas relacionadas con Timeline también",
    "confirm": "Confirmar",
    "cancel": "Cancelar"
  },
  "de": {
    "title": "Zeitachse einfügen",
    "horizontal": "Horizontal",
    "vertical": "Vertikal",
    "openLib": "Zeitachse-bezogene Galerie gleichzeitig öffnen",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "jp": {
    "title": "タイトルラインを挿入",
    "horizontal": "横",
    "vertical": "縦",
    "openLib": "関連するライブラリーを開く",
    "confirm": "確認",
    "cancel": "キャンセル"
  },
  "tw": {
    "title": "插入時間線",
    "horizontal": "水平時間線",
    "vertical": "垂直時間線",
    "openLib": "同时打开時間線相關圖庫",
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "title": "타임라인 삽입",
    "horizontal": "수평 타임라인",
    "vertical": "수직 타임라인",
    "openLib": "타임라인과 관련된 이미지 동시에 열기",
    "confirm": "확인 ",
    "cancel": "취소 "
  }
}
</i18n>
